import { delay, put, takeEvery, call, select } from 'redux-saga/effects';
import { RequestConfigListAction } from 'redux/actions/type';
import { REQUEST_CONFIG_LIST, REQUEST_STORAGE_LIST } from 'redux/actions/types';
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import {
  requestConfigListSuccess,
  requestConfigListFailure,
  throwError,
} from 'redux/actions/actions';
import { PaginationType } from 'commons/framework/type';
import ConfigVO from 'commons/vo/ConfigVO';
import { AxiosResponse } from 'axios';

function* requestConfigListSaga(action: RequestConfigListAction) {
  try {
    const response: AxiosResponse = yield call(getAPI, API.CONFIG);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: ConfigVO[] = keyFlowResponse.getResult(ConfigVO) as ConfigVO[];
    const config = resultList[0];
    console.log({ config });
    yield put(
      requestConfigListSuccess({
        config,
      }),
    );
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestConfigListFailure());
  }
}

export function* watchConfigSaga() {
  yield takeEvery(REQUEST_CONFIG_LIST, requestConfigListSaga);
}
